import { useRef } from 'react';
import InsightsGrid from './InsightsGrid/InsightsGrid';
import { DashboardContentViewHeader } from './DashboardContentViewHeader';
import DrillDownSidePanel from './DrillDownSidePanel/DrillDownSidePanel';

const DashboardsContentView = () => {
  const gridRef = useRef<any>();

  return (
    <div className='relative w-full h-full'>
      <div className='pb-4 px-6'>
        <DashboardContentViewHeader gridRef={gridRef} />
        <InsightsGrid ref={gridRef} />
        <DrillDownSidePanel />
      </div>
    </div>
  );
};

export default DashboardsContentView;
